export default __webpack_public_path__ + "static/media/shareLeft@2x.a2d026b4.png";